<template>
  <v-dialog v-model="openModal" width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Favoritos</span>
      </v-card-title>
      <v-card-text>

        <v-list>
          <template v-for="(item, index) in favoritesGroupList">
            <v-divider :key="index" :class="index !== 0 ? 'mt-3' : 'mt-0'"></v-divider>
            <v-subheader :key="item.title"
            ><h2 class="title primary--text text--darken-2"> {{item.title}}</h2> </v-subheader>
            

              <v-list-tile
                :key="code.value+index"
                v-for="code in item.items"
                class="py-1"
                @click="selection = code.value">
                <v-list-tile-content >
                  <v-list-tile-title >{{code.text}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{code.value}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import * as algolia from '../../services/algolia.js'
export default {
  props: {
    value: { default: null },
    label: { type: String, default: 'Pesquisa de diagnóstico' },
    excludedCodes: { default: () => [] },
    searchIndex: { type: String, default: 'codes_10_cm' },
    itemValue: { type: String, default: 'value' },
    itemText: { type: String, default: 'text' },
    showFavorites: { type: Boolean, default: false },
    showFavoritesTable: { type: Boolean, default: false },
    logbook: { type: String }
  },
  data() {
    return {
      loading: false,
      openModal: false,
      items: [],
      select: null,
      favouritesList: [],
      outpatientGroupList: [{
        title: 'Gónadas',
        icdCodes: ['N62','N528','E291','N461','T387X5A','L680','E282','E2831','F640','Q969','Q984'],
        items: []
      },{
        title: 'Diabetes Mellitus',
        icdCodes: ['E109','E108','E102','E103','E104','E105','E13','E119','E118','E112','E113','E114','E115','E099','O24419'],
        items: []
      },{
        title: 'Tiroideia',
        icdCodes: ['E02','E041','E042','E0510','E0520','C73','E0500','E0590','E061','E063','E039','E890','E032','E0781'],
        items: []
      },{
        title: 'Paratiroide',
        icdCodes: ['E209','E892','E210','E211'],
        items: []
      },{
        title: 'Hipófise',
        icdCodes: ['E220','E230','E893','E240','D352','E221','D444','E232'],
        items: []
      },{
        title: 'Supra renal',
        icdCodes: ['D3500','E249','E270','E240','E275','E2609','E271','E250'],
        items: []
      },{
        title: 'Obesidade',
        icdCodes: ['E6601','E669'],
        items: []
      },{
        title: 'Pediatria',
        icdCodes: ['E301','E300', 'R6252'],
        items: []
      },{
        title: 'Outros',
        icdCodes: ['D447','E310','E3121','E3122','E3123','E780','D137'],
        items: []
      }],
      inpatientGroupList: [{
        title: 'Diabetes Mellitus',
        icdCodes: ['E1010','E1110','E1100','E1065','E1165','E162','E10621','E11621'],
        items: []        
      },{
        title: 'Tiroideia',
        icdCodes: ['E0591','E035'],
        items: []        
      },{
        title: 'Paratiroide',
        icdCodes: ['E8352','E8351'],
        items: []        
      },{
        title: 'Hipófise',
        icdCodes: ['E871','E870','E236'],
        items: []        
      },{
        title: 'Supra renal',
        icdCodes: ['E2740'],
        items: []        
      }]
    }
  },
  computed: {
    selection: {
      get() {
        const [value] = (this.value || ':').split(':')
        return value
      },
      set(value) {
        let item = this.items.find(i => i.value === value)

        if (!item) {
          item = this.favouritesList.find(i => i.value === value)
        }

        const output = value && `${item.value}:${item.text}`
        this.$emit('input', output)
        this.openModal = false
      }
    },
    favoritesGroupList() {
      let list = []
      if(this.logbook === 'inpatient') {
        list = JSON.parse(JSON.stringify(this.inpatientGroupList))
      } else if (this.logbook === 'outpatient') {
        list = JSON.parse(JSON.stringify(this.outpatientGroupList))
      }
      list.forEach((group, index) => {
        this.favouritesList.forEach(item => {
          if(group.icdCodes.includes(item.value)) {
            list[index].items.push(item)
          }
        })
      })
      return list
    }
  },
  watch: {
    openModal(val, old) {
      if(val === false && val !== old) {
        this.$emit('update:showFavoritesTable', val)
      }
    },
    showFavoritesTable(val) {
      if(val === true) {
        this.openModal = true
      }
    }
  },
  methods: {

  },
  created() {
    algolia
      .search('', this.searchIndex, this.$store.getters.accessToken, {
        favourites: true,
        specialty: this.$store.getters.specialty
      })
      .then(results => {
        this.favouritesList = results.map(item => ({
          text: item[this.itemText],
          value: item[this.itemValue]
        }))
      })
    if (this.value) {
      const [value, text] = (this.value || ':').split(':')
      this.items = [{ value, text }]
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
